import clone from 'lodash/clone';

const messages = [
  {
    code: 'EnumGlobalStockStatus1',
    cssClass: 'text-green',
    label: 'stockInStock',
    description: 'stockInStockDescription',
  },
  {
    code: 'EnumGlobalStockStatus4',
    cssClass: 'text-red',
    label: 'stockOutOfStock',
    description: 'stockOutOfStockDescription',
  },
  {
    code: 'EnumGlobalStockStatus5',
    cssClass: 'text-red',
    label: 'stockComingSoon',
    description: 'stockComingSoonDescription',
  },
  {
    code: 'EnumGlobalStockStatus8', // BTO Out of Stock
    cssClass: 'text-orange',
    label: 'stockBto',
    description: 'stockBtoDescription',
  },
  {
    code: 'EnumGlobalStockStatus9', // BTO In Stock
    cssClass: 'text-orange',
    label: 'stockBto',
    description: 'stockBtoInStockDescription',
    explanation: 'stockBtoInStockExplanation',
  },
];

/**
 * Get message by given stock availability code.
 * @param code
 * @return {{code: string, cssClass: string, description: string, label: string}} | null
 */
const getMessageByCode = (code) => {
  return clone(messages.find((message) => message.code === code));
};
/**
 * Check whether the status is in stock or not by given stock status code.
 * @param stockStatusCode
 * @return {boolean}
 */
const isInStockByCode = (stockStatusCode) => {
  return stockStatusCode === 'EnumGlobalStockStatus1';
};

/**
 * Check whether the status is in warehouse or not by given stock status code.
 * @param stockStatusCode
 * @return {boolean}
 */
const isInWarehouseByCode = (stockStatusCode) => {
  return stockStatusCode === 'EnumGlobalStockStatus6';
};

/**
 * Check whether the status is 'Build to Order' or not.
 * @param stockStatusCode
 * @return {boolean}
 */
const isBuildToOrderByCode = (stockStatusCode) => {
  return stockStatusCode === 'EnumGlobalStockStatus8';
};

/**
 * Check whether the status is 'Build to Order In Stock' or not.
 * @param stockStatusCode
 * @return {boolean}
 */
const isBuildToOrderInStockByCode = (stockStatusCode) => {
  return stockStatusCode === 'EnumGlobalStockStatus9';
};

/**
 * Get retailer stock message by stock status code and product type.
 * @param isBike
 * @param stockStatusCode
 * @return {string}
 */
const getRetailerStockMessage = (isBike, stockStatusCode) => {
  switch (stockStatusCode) {
    case 'EnumGlobalStockStatus1':
      return isBike ? 'retailerBikeInStock' : 'retailerAftermarketInStock';

    case 'EnumGlobalStockStatus6':
      return isBike ? 'retailerBikeInWarehouse' : 'retailerAftermarketInWarehouse';

    default:
      return isBike ? 'retailerBikeContactRetailer' : 'retailerAftermarketContactRetailer';
  }
};

export {
  getMessageByCode,
  isInStockByCode,
  getRetailerStockMessage,
  isInWarehouseByCode,
  isBuildToOrderByCode,
  isBuildToOrderInStockByCode,
};
